// extracted by mini-css-extract-plugin
export default {"arrow":"q9wKUmb6nGBwSKpi2H_M","title":"saOjzczxBw6iarZA66cD","body":"HHFdPJtxBji1PXi6G0D_","root":"M5NBJjlrOLgaaTunXddN"};